import AiLabel from "@/components/ai-label";
import { CustomCategory } from "@/components/category";
import PodcastPlayButton from "@/components/podcast-play-button";
import TeaserHeading from "@/components/teaser-heading";
import TeaserLinkedContent from "@/components/teaser-linked-content";
import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";

type LargeProps = {
  podcast: Content.PodcastEpisode;
  imagePriority?: boolean;
};

const Large = (props: LargeProps) => {
  const podcastShow = props.podcast.fields["podcast-show"];
  const hasLinkedContent = Boolean(props.podcast.fields.linkedContent?.length);
  const image = props.podcast.fields.teaserImage || props.podcast.fields.image;
  const title = props.podcast.fields.teaserTitle || props.podcast.fields.title;

  return (
    <div>
      <Link
        href={`/podd/${props.podcast.fields.slug}`}
        className={classNames(
          "cursor-pointer group block relative pb-4 border-b border-sand-800",
        )}
      >
        <div className="group flex gap-4">
          {image?.fields.file?.url && (
            <div className="relative w-[200px] h-auto">
              <div className="aspect-w-1 aspect-h-1 bg-sand-800">
                <Image
                  priority={props.imagePriority ? true : false}
                  fill
                  src={createImageUrl(image.fields.file.url, {
                    crop: "1:1",
                  })}
                  alt={image.fields.alt || ""}
                  className="object-cover"
                  sizes={createImageSizes({
                    mobile: "100vw",
                    tablet: "50vw",
                    desktop: "33vw",
                  })}
                />
                <AiLabel image={image} />
              </div>
            </div>
          )}
          <div>
            {podcastShow && (
              <CustomCategory color="Podd" name={podcastShow.fields.title} />
            )}

            {title && (
              <TeaserHeading
                text={title}
                className="text-3xl mb-2 font-semibold"
              />
            )}

            {props.podcast.fields.media?.mediaUrl && (
              <PodcastPlayButton podcast={props.podcast} />
            )}
          </div>
        </div>
      </Link>
      {hasLinkedContent && (
        <div className="">
          <TeaserLinkedContent
            linkedContent={props.podcast.fields.linkedContent}
            compactMode={false}
            showLinkedContent={true}
            darkMode={false}
          />
        </div>
      )}
    </div>
  );
};

export default Large;
